module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"version":{"uploadForm":{"title":"Version Upload","secretKey":"Secret Key","file":"Select file"}}}}')
  delete Component.options._Ctor
}
